(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    class ReadMoreText extends HTMLElement {
    connectedCallback() {
      this._expanded = false;
      this._content = this.querySelector('.text-block');
      this._button = this.querySelector('[data-read-more-button]');

      if (!this._content || !this._button) return;

      // Activate CSS clamping via class (progressive enhancement).
      // The initial check is intentionally deferred to the ResizeObserver
      // callback, which fires after the browser has applied the new styles
      // and recalculated layout. Calling _check() synchronously here would
      // read stale (pre-max-height) dimensions and produce wrong results.
      this.classList.add('read-more-text--init');

      // Re-check when the element is resized (viewport changes, reflow, etc.).
      // The first callback fires asynchronously after the initial layout pass,
      // so CSS max-height is already applied at that point.
      this._observer = new ResizeObserver(() => {
        if (!this._expanded) this._check();
      });
      this._observer.observe(this._content);

      // Re-check once all fonts are loaded — web fonts affect computed line count.
      document.fonts.ready.then(() => {
        if (!this._expanded) this._check();
      });

      this._button.addEventListener('click', () => this._toggle());
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    _check() {
      // scrollHeight > clientHeight means content is taller than the clamped box.
      // When text fits within the configured lines, the button must be
      // completely hidden — invisible AND unreachable by assistive technology.
      //
      // A 2px tolerance handles sub-pixel rounding: scrollHeight and
      // clientHeight are integers, so content that is fractionally taller
      // than max-height can report scrollHeight == clientHeight + 1 even
      // when it visually overflows.
      this._button.hidden = this._content.scrollHeight <= this._content.clientHeight + 2;
    }

    _toggle() {
      this._expanded = !this._expanded;
      this.classList.toggle('read-more-text--expanded', this._expanded);
      this._button.setAttribute('aria-expanded', String(this._expanded));

      const context = this.dataset.context;
      const action = this._expanded ? 'less' : 'more';
      this._button.textContent = this._expanded ? 'Read less' : 'Read more';

      if (context) {
        this._button.setAttribute('aria-label', `Read ${action} about ${context}`);
      } else {
        this._button.removeAttribute('aria-label');
      }

      // After collapsing, re-check whether the button should still be visible
      if (!this._expanded) this._check();
    }
  }

  if (!customElements.get('read-more-text')) {
    customElements.define('read-more-text', ReadMoreText);
  }
  } catch(e) { console.error(e); }
})();

})();
